import { UserDetails } from '../../models/userDetailsType';

export type AdminUsersState = {
  usersDetails: UserDetails[];
  loading: boolean;
  error: Error | null;
};

export const initialState: AdminUsersState = {
  usersDetails: [],
  loading: false,
  error: null,
};
